import * as common from '@/modules/common/api'
import * as content from '@/modules/content/api'

const api = Object.assign({},
  common,
  content
)

export default api
